import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';

Snappy.Component.ContentPromoHero = class ContentPromoHero extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
	}
};

$(function() {
    
    function repositionTextbox(){   
        var containerHeight = $('.fa-content-promo.fa-content-promo--hero').height();
        var textboxHeight = $('.fa-content-promo__content--colour-overlay').height();
        var offsetPosition = ((parseInt(containerHeight) - parseInt(textboxHeight)) / 2) - 25;

        $('.fa-content-promo__content--colour-overlay').css({"bottom":Math.abs((offsetPosition))});
    }

    repositionTextbox();
    $( window ).resize(repositionTextbox);

    
    
})



// WEBPACK FOOTER //
// ./components/contentPromoHero/scripts/contentPromoHero.js